export const USER_QUERY_KEYS = {
  account: ['account'],
  cognitoUser: ['cognitoUser'],
  userApiKey: ['userApiKey'],
  userData: ['userData'],
  userSettings: (isAuthenticated = false, spaceId = '', isSuperUser = false) => [
    'userSettings',
    isAuthenticated,
    spaceId,
    isSuperUser,
  ],
} as const;
